import { Typography } from "@mui/material";
import { type FC, useMemo, useState } from "react";

import { PercentageComponent } from "~/components/UI/PercentageComponent";
import { MarketStatus, type MarketStatusValue } from "~/types/event";

interface IVolumePercentageFieldProps {
  percentage?: number | null;
  createdAt?: string | null;
  isResolved?: boolean;
  marketStatus?: MarketStatusValue;
  periodDays: 1 | 7;
  isBold?: boolean;
}

export const VolumePercentageField: FC<IVolumePercentageFieldProps> = ({
  percentage,
  createdAt,
  isResolved = false,
  marketStatus,
  periodDays,
  isBold,
}) => {
  const [startTime] = useState(() => Date.now());

  const isClosedStatus = useMemo(() => {
    return (
      !!marketStatus &&
      (marketStatus === MarketStatus.CLOSED ||
        marketStatus === MarketStatus.RESOLVED)
    );
  }, [marketStatus]);

  const isYoungerThanRequiredPeriod = useMemo(() => {
    if (!createdAt) return false;

    const createdAtTime = new Date(createdAt).getTime();
    if (Number.isNaN(createdAtTime)) return false;

    const requiredAgeInMs = periodDays * 24 * 60 * 60 * 1000;
    return startTime - createdAtTime < requiredAgeInMs;
  }, [createdAt, periodDays, startTime]);

  if (
    isClosedStatus ||
    isResolved ||
    (isYoungerThanRequiredPeriod && !percentage)
  ) {
    return (
      <Typography variant="caption" sx={{
        fontWeight: isBold ? 600 : 400
      }}>N/A
              </Typography>
    );
  }

  if (percentage === null) {
    return (
      <Typography variant="caption" sx={{
        fontWeight: isBold ? 600 : 400
      }}>N/A
              </Typography>
    );
  }

  return <PercentageComponent percentage={percentage} isBold={isBold} />;
};
